module.exports = __webpack_public_path__ + "static/img/read-back-noData.4aee0ccc.png";